import { createSlice } from '@reduxjs/toolkit';
import { PaginatedResponse, EstablishmentRating, DriverRating, CustomerRating } from './types';

type RatingsState = {
  establishmentRatings: PaginatedResponse<EstablishmentRating>;
  driverRatings: PaginatedResponse<DriverRating>;
  customerRatings: PaginatedResponse<CustomerRating>;
  ratingsLoading: boolean;
  detailedRatingLoading: boolean;
};

const initialState: RatingsState = {
  establishmentRatings: {
    total: 0,
    per_page: 10,
    current_page: 0,
    last_page: 0,
    first_page: 0,
    first_page_url: '',
    last_page_url: '',
    next_page_url: null,
    previous_page_url: null,
    data: [],
  },
  driverRatings: {
    total: 0,
    per_page: 10,
    current_page: 0,
    last_page: 0,
    first_page: 0,
    first_page_url: '',
    last_page_url: '',
    next_page_url: null,
    previous_page_url: null,
    data: [],
  },
  customerRatings: {
    total: 0,
    per_page: 10,
    current_page: 0,
    last_page: 0,
    first_page: 0,
    first_page_url: '',
    last_page_url: '',
    next_page_url: null,
    previous_page_url: null,
    data: [],
  },
  ratingsLoading: true,
  detailedRatingLoading: true,
};

const ratingsSlice = createSlice({
  name: 'ratings',
  initialState,
  reducers: {
    setEstablishmentRatings(state, action) {
      state.establishmentRatings = action.payload;
    },
    setDriverRatings(state, action) {
      state.driverRatings = action.payload;
    },
    setCustomerRatings(state, action) {
      state.customerRatings = action.payload;
    },
    setRatingsLoading(state, action) {
      state.ratingsLoading = action.payload;
    },
    setDetailedRatingLoading(state, action) {
      state.detailedRatingLoading = action.payload;
    },
    resetRatingsState(state) {
      state.establishmentRatings = initialState.establishmentRatings;
      state.driverRatings = initialState.driverRatings;
      state.customerRatings = initialState.customerRatings;
      state.ratingsLoading = initialState.ratingsLoading;
      state.detailedRatingLoading = initialState.detailedRatingLoading;
    },
  },
});

export const {
  setEstablishmentRatings,
  setDriverRatings,
  setCustomerRatings,
  setRatingsLoading,
  setDetailedRatingLoading,
  resetRatingsState,
} = ratingsSlice.actions;

export default ratingsSlice.reducer;